import React, { useState, useEffect } from "react";
import { Navbar, Container, Image, Nav, Row, Col, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./Landing.css";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-multi-lang";
import { fetchCategoriesListStart } from "../../store/slices/HomePageSlice";
import Skeleton from "react-loading-skeleton";

const FavouritesProduct = (props) => {

  const dispatch = useDispatch();
  const t = useTranslation("faviorite_product");
  const categoriesList = useSelector(state => state.homepage.categoriesList);

  return (
    <>
      <div className="favourites-product-sec">
        <Container>
          <Row>
            <Col md={12} xl={4} lg={4} className="resp-marg-btm-md">
              <div className="favourites-product-content">
                <h5 className="text-uppercase">{t("find_your_favourites")}</h5>
                <h2>{t("add_to_your_jewellery_wardrobe")}</h2>
                <Link to="/products" className="download-receipt-btn text-uppercase">
                  {t("all_categories")}
                </Link>
              </div>
            </Col>
            <Col md={12} xl={8} lg={8}>
              {categoriesList.loading ?
                <div className="favourites-product-box">
                  {[...Array(6)].map((i) => <Skeleton height={225} width={225} key={i} />)}
                </div>
                :
                Object.keys(categoriesList.data).length > 0 &&
                  categoriesList.data.categories.length > 0
                  ?
                  <div className="favourites-product-box">
                    {categoriesList.data.categories.map(
                      (category, i) => (
                        <Link to={`/products?category=${category.category_unique_id}`} key={i}>
                          < div className="favourites-product-card" >
                            <div className="favourites-product-img-sec">
                              <Image
                                className="favourites-product-img"
                                src={
                                  category.picture}
                              />
                            </div>
                            <div className="favourites-product-info">
                              <h4 className="uppercase">{category.name}</h4>
                            </div>
                          </div>
                        </Link>
                      ))}
                  </div>
                  :
                  null
              }
            </Col>
          </Row>
        </Container>
      </div >
    </>
  );
};

export default FavouritesProduct;
